// extracted by mini-css-extract-plugin
export default {"detailsContainer":"buy-contract-modal_detailsContainer__ku0eg"};